import React from 'react';
import CouponForm from './form';
import {getProductItem, updateCouponItem, updateProductItem} from '../../modules/Api';
import {normalizer, prepareForEdit} from './pipeline';
import {notification} from 'antd';
import history from '../../modules/History';

class EditProduct extends React.Component {
    constructor() {
        super();
        this.state = {
            data: {},
            submitted: false
        }
        
    }
    componentDidMount() {
        this.fetchCouponDetail();
    }
    fetchCouponDetail() {
        const productId = this.props.match.params.id;
        getProductItem(productId, data => {this.setState({data: prepareForEdit(data)})});
    }
    submit(values) {
        if(this.state.submitted){
            return;
        }
        this.setState({submitted: true});
        const productId = this.props.match.params.id;
        const formData = normalizer(values, this.state.data);
        updateProductItem(productId, formData, () => {
            notification.open({
                message: `محصول با موفقیت ویرایش شد!`,
                description: ``
            });
            this.setState({submitted: false});
            history.item.push(`/products`);
        })
    }
    render() {
        if(!this.state.data.id){
            return (<div>لطفا منتظر بمانید</div>);
        }
        return (<div><CouponForm initialData={this.state.data} submit={this.submit.bind(this)} submitted={this.state.submitted}/></div>);
    }
}

export default EditProduct;


// WEBPACK FOOTER //
// ./src/containers/Products/edit.js